
    <template>

     
  <div class="card color_light" style="  " >
      <!-- <div v-for="content in boxdata"  v-bind:key="content"> -->
       <div> {{ $t('product.clientProductId')}} :  <span class="textcolor">  {{boxdata.productid}} </span> </div>
      <div> {{ $t('orders.ean')}} : <span class="textcolor">  {{boxdata.ean}}</span> </div>
        <div> {{ $t('purchaseOrder.ProductName')}} :<span class="textcolor">  {{boxdata.productname}}</span>  </div>
         <div>  {{ $t('boxList.quantity')}} :<span class="textcolor">  {{boxdata.quantity}}</span> </div>

        
      <!-- </div> -->
    <div class="col-md-12 mb-1">
        </div>
  </div>

    </template>
    
    <script>
import LoginVue from '../pages/Login.vue'
    export default {
        name:'Singleboxitem',
        components:{},
        props:['boxdata'],
      
       

        data:function(){
            return{
                
            }

        },
        mounted(){

        },
        methods:{
            
        }
    }
// e9e6e6 
    </script>
    
    <style>
      .color_light{
        background-color:#dcecf3;
            margin:0rem 0.3rem;
        border: 2px solid #c7ece2;
        border-radius: 5px;
        box-shadow: 0px 4px 4px rgba(148, 150, 151, 0.747);
        padding: 5px 10px;
    }
    .textcolor{
        color:black;
        font-weight: bold;
        font-family: 'Courier New', Courier, monospace;
        }
        
    </style>


// WEBPACK FOOTER //
// src/views/common_components/singleBoxItem.vue?4c8370dc